export class Pagination {
    currentPage: number;
    pageSize: number;
    totalPages: number;
    totalResults: number;
    firstResultCurrentPage: number;
    lastResultCurrentPage: number;
    sortOption: string;
    sortOrder: string;
}
